import { render, staticRenderFns } from "./ShiftsBoard.vue?vue&type=template&id=293277be&scoped=true"
import script from "./ShiftsBoard.vue?vue&type=script&lang=js"
export * from "./ShiftsBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293277be",
  null
  
)

export default component.exports